import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { eventSpaces } from '../../data/shreeData';
import { Users, Check } from 'lucide-react';

const EventsSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="events" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-purple-100 text-purple-700 hover:bg-purple-200">Events & Celebrations</Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Host Your Special Occasions
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From weddings to corporate events, our versatile venues are perfect for any celebration
          </p>
        </div>

        {/* Event Spaces Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {eventSpaces.map((space, index) => (
            <Card 
              key={space.id} 
              className="group overflow-hidden hover:shadow-2xl transition-all duration-500 border-0"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={space.image}
                  alt={space.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute top-4 right-4">
                  <Badge className="bg-white/95 text-purple-700">
                    <Users className="w-3 h-3 mr-1 inline" />
                    {space.capacity} Capacity
                  </Badge>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              
              <CardContent className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  {space.name}
                </h3>
                
                <p className="text-gray-600 mb-4">{space.description}</p>

                <div className="space-y-2">
                  {space.features.slice(0, 3).map((feature, i) => (
                    <div key={i} className="flex items-center text-sm text-gray-600">
                      <Check className="w-4 h-4 mr-2 text-teal-600 flex-shrink-0" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-teal-700 to-teal-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Plan Your Dream Event With Us
          </h3>
          <p className="text-xl mb-8 text-teal-50 max-w-2xl mx-auto">
            Our experienced event planning team will help you create unforgettable memories
          </p>
          <Button 
            onClick={scrollToContact}
            size="lg"
            className="bg-white text-teal-700 hover:bg-gray-100 text-lg px-8"
          >
            Get a Quote
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
